export const ALL_EVENT_TYPES = 'ALL_EVENT_TYPES';
export const ENABLED_TOGGLED = 'ENABLED_TOGGLED';
export const DISABLED_TOGGLED = 'DISABLED_TOGGLED';
export const ENROLLMENT_MODIFIED = 'ENROLLMENT_MODIFIED';
export const ENABLED_REENROLLMENT = 'ENABLED_REENROLLMENT';
export const DISABLED_REENROLLMENT = 'DISABLED_REENROLLMENT';
export const REENROLLMENT_MODIFIED = 'REENROLLMENT_MODIFIED';
export const UNENROLLMENT_MODIFIED = 'UNENROLLMENT_MODIFIED';
export const GOALS_MODIFIED = 'GOALS_MODIFIED';
export const EDITED_NAME = 'EDITED_NAME';
export const ACTION_MODIFICATION = 'ACTION_MODIFICATION';
export const TIME_WINDOW_MODIFIED = 'TIME_WINDOW_MODIFIED';
export const CREATED_WORKFLOW = 'CREATED_WORKFLOW';
export const MERGE_SETTING_MODIFIED = 'MERGE_SETTING_MODIFIED';
export const SUPPRESSION_LIST_MODIFIED = 'SUPPRESSION_LIST_MODIFIED';
export const UNKNOWN_AUDIT_EVENT_TYPE = 'UNKNOWN_AUDIT_EVENT_TYPE';